import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {BranchService} from "../../../services/branch.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-user-branches-update',
  templateUrl: './user-branches-update.component.html',
  styleUrls: ['./user-branches-update.component.scss']
})
export class UserBranchesUpdateComponent implements OnInit{

  userForm: FormGroup;
  branches: any[] = [];
  branchSelected: number | undefined;
  saving = false;

  public data: any;

  public user: any;

  isSubmitted = false;
  val: any | null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private userService: UserService,
              private translate: TranslateService,
              private toast: ToastrService,
              private branchService: BranchService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.userForm = this.fb.group({
      userBranches: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {
      console.log(this.data);
    this.userForm.patchValue(this.data);
    //this.branchSelected = this.data?.userBranches?.map((c: any) => c['@id']);
    this.getUser()
    this.findBranches();
  }

    getUser(): any
    {
        this.userService.get(this.data.id).subscribe({
            next: (res: any) => {
                this.user = res;

                console.log(this.user);

                this.branchSelected = this.user?.userBranches?.map((c: any) => c['@id']);

                // // cache our list
                // this.temp = [...res['hydra:member']];
                //
                // this.rows = this.users;
            },
            error: (error: HttpErrorResponse) => {
                console.log(error.message);
                console.log('Error while fetching the records');
            }
        });
    }

  get fc(): any {
    return this.userForm.controls;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.userForm.valid){
      this.saving = true;
      if (this.data){
        this.userService.userBranchesUpdate(this.data.id, this.userForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('branches') + ' ' + this.translate.instant('edited') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err.error.violations;

            errors.forEach((v) =>
            {
              if (v.propertyPath === 'userBranches'){
                this.userForm.get('userBranches')?.setErrors({serverError: v.message});
              }
              this.saving = false;

            });
          }
        });
      }

    }
  }

  findBranches(): any{
    this.branchService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.branches = data['hydra:member'];
          this.branches = this.branches.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }


}
